import { PencilOffIcon } from './PencilOffIcon';

/**
 * author: Simran
 * id AEB0F9CD-B3FF-4F64-9D6E-4916D5C720C3
 * name pencil-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-off.svg
 * tags
 */
export const EditOffIcon = PencilOffIcon;
export default EditOffIcon